import React from 'react';

import { TagStatusLight, type TagStatusLightProps } from '@clubspark-react/ui/core';

interface PlayerStatusProps {
  status: 'Selected' | 'Alternate' | 'Unpaired' | 'Withdrawn';
}

const getStatusVariant = (playerStatus?: PlayerStatusProps['status']): TagStatusLightProps['variant'] => {
  switch (playerStatus) {
    case 'Selected':
      return 'highlight1Outline';
    case 'Alternate':
      return 'warningOutline';
    case 'Unpaired':
      return 'pendingOutline';
    case 'Withdrawn':
      return 'destructiveOutline';
  }
  return 'pendingOutline';
};

const getDisplayStatus = (playerStatus?: PlayerStatusProps['status']): string => {
  // eslint-disable-next-line no-nested-ternary
  return playerStatus || '-';
};

export const PlayerStatus: React.FC<React.PropsWithChildren<PlayerStatusProps>> = React.memo(({ status }) => {
  const variant = getStatusVariant(status);
  const text = getDisplayStatus(status);

  return (
    <TagStatusLight sx={{ margin: '1px' }} variant={variant}>
      {text}
    </TagStatusLight>
  );
});
